<template>
  <v-card flat>
    <v-container class="ma-0 mp-0">
      <v-row no-gutters>
        <v-col cols="1" offset="1">
          <v-subheader>Camaigns</v-subheader>
        </v-col>
        <v-col cols="6">
          <email-campaign-multiselect
            v-model="emailCampaigns"
            :dealer_id="dealer.id">
          </email-campaign-multiselect>
        </v-col>
        <v-col cols="3" offset="1">
          <template v-if="numberOfDays">
            <h1 class="offset-header green--text">{{ numberOfDays }}</h1>
            <v-subheader>Number of days in report</v-subheader>
         </template>
        </v-col>
      </v-row>
      <v-row no-gutters>
        <v-col cols="1" offset="1">
          <v-subheader>Start Date</v-subheader>
        </v-col>
        <v-col cols="3">
          <ymd-datepicker
            v-model="startDate"
            label="Start Date"
            required
            :rules="vruleFieldRequired"
            hint="*Required"
            persistent-hint
          ></ymd-datepicker>
        </v-col>
     </v-row>
      <v-row no-gutters>
        <v-col cols="1" offset="1">
          <v-subheader>End Date</v-subheader>
        </v-col>
        <v-col cols="3">
          <ymd-datepicker
            v-model="endDate"
            label="End Date"
            required
            :rules="vruleFieldRequired"
            hint="*Required"
            persistent-hint
          ></ymd-datepicker>
        </v-col>
      </v-row>
      <v-row no-gutters>
        <v-col cols="1" offset="1">
          <v-subheader>Days Between</v-subheader>
        </v-col>
        <v-col cols="3">
          <v-text-field
            v-model="daysBetween"
            placeholder="Days Between"
            persistent-hint
            hint="Minimum Days Between Transactions"
            suffix="days"
            required
            :rules="vruleFieldRequired"
            type="number"
            min="0"
            step="1"
          ></v-text-field>
        </v-col>
      </v-row>
      <v-row no-gutters>
        <v-col cols="1" offset="1">
          <v-subheader>Campaign Timespan</v-subheader>
        </v-col>
        <v-col cols="3">
          <v-text-field
            v-model="campaignTimespan"
            placeholder="Campaign Timespan"
            persistent-hint
            hint="Count transactions this many days after the campaign was created."
            suffix="days"
            required
            :rules="vruleFieldRequired"
            type="number"
            min="0"
            step="1"
          ></v-text-field>
        </v-col>
      </v-row>
    </v-container>
  </v-card>
</template>

<script>
import { YMDDatePicker, EmailCampaignMultiSelect } from '@/components/inputs'
import validationMixin from '@/validators/validations_mixin'
import { hasValue } from '@/utils'
import { mapState } from 'vuex'
import { DateTime } from 'luxon'

export default {
  name: 'campaign-select-input',
  displayName: 'Campaign Select and Date Range',
  title: 'Select campaign(s) and report dates',
  mixins: [validationMixin],
  components: {
    [YMDDatePicker.name]: YMDDatePicker,
    [EmailCampaignMultiSelect.name]: EmailCampaignMultiSelect
  },

  props: {
    value: {
      type: Object,
      required: true
    }
  },
  data: function () {
    return {
      startDate: null,
      endDate: null,
      daysBetween: 7,
      emailCampaigns: [],
      campaignTimespan: 45
    }
  },
  computed: {
    ...mapState('DealerStore', ['dealer']),
    numberOfDays () {
      if (hasValue(this.startDate) && hasValue(this.endDate)) {
        return DateTime.fromISO(this.endDate).diff(DateTime.fromISO(this.startDate), 'days').toObject().days
      } else {
        return ''
      }
    }
  },
  watch: {
    emailCampaigns: function () {
      this.updateState()
    },
    startDate: function () {
      this.updateState()
    },
    endDate: function () {
      this.updateState()
    },
    daysBetween: function () {
      this.updateState()
    },
    campaignTimespan: function () {
      this.updateState()
    }
  },
  methods: {
    mdyDate (dateObj) {
      return dateObj.toISODate()
    },
    updateState () {
      const payload = {
        startDate: this.startDate,
        endDate: this.endDate,
        daysBetween: this.daysBetween,
        emailCampaigns: this.emailCampaigns,
        campaignTimespan: this.campaignTimespan
      }
      this.$emit('input', payload)
    },
    setDefaultTimeframe () {
      this.endDate = this.mdyDate(DateTime.now())
      this.startDate = this.mdyDate(DateTime.now().minus({ days: this.campaignTimespan }))
    }
  },
  mounted () {
    this.setDefaultTimeframe()
  }
}
</script>

<style scoped>
  .offset-header {
    padding: 0 16px 0 16px
  }
</style>
